module.exports = __webpack_public_path__ + "img/second.2423b3ec.jpg";